import { render, staticRenderFns } from "./contas-receber.vue?vue&type=template&id=3734fe2b&scoped=true"
import script from "./contas-receber.vue?vue&type=script&lang=js"
export * from "./contas-receber.vue?vue&type=script&lang=js"
import style0 from "./contas-receber.vue?vue&type=style&index=0&id=3734fe2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734fe2b",
  null
  
)

export default component.exports